import { LastActivityType } from '@/modules/group/modules/groups/domain/models/LastActivityType'

import { axios, Response } from '../index'

export default async function lastActivityArchived(): Response<
  LastActivityType[]
> {
  return await axios.get(`/v1/groups-archived`)
}
